/**
 * Datumsformatierung wie im Altclient: Die API liefert ISO-Strings, die erst im Renderer
 * (`IwmSharedColumnsDate`) in `dd.MM.yyyy` umgewandelt werden.
 */

/** Reines Datum ohne Zeitanteil, z. B. `2024-03-05`. */
const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

function pad(value: number, length = 2): string {
  return value.toString().padStart(length, '0');
}

/** Wandelt einen API-Wert in ein `Date`; leere oder ungültige Werte ergeben `null`. */
export function parseApiDate(value: string | Date | null | undefined): Date | null {
  if (value === null || value === undefined) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const text = value.trim();
  if (text === '') return null;

  // Ein reines Datum liest JavaScript als UTC — das würde den Tag verschieben.
  // Mit angehängter Nullzeit wird es wie ein .NET-`DateTime` als Ortszeit gelesen.
  const parsed = DATE_ONLY_PATTERN.test(text) ? new Date(`${text}T00:00:00`) : new Date(text);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/** `dd.MM.yyyy`; leerer String bei fehlendem Wert. */
export function formatDate(value: string | Date | null | undefined): string {
  const date = parseApiDate(value);
  if (date === null) return '';
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${pad(date.getFullYear(), 4)}`;
}

/** `dd.MM.yyyy HH:mm`; leerer String bei fehlendem Wert. */
export function formatDateTime(value: string | Date | null | undefined): string {
  const date = parseApiDate(value);
  if (date === null) return '';
  return `${formatDate(date)} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
